import { createSelector } from 'reselect';
import { RootState } from './store';

const wholeState = (state: RootState) => state;

export const selectGlobalLoading = createSelector(
  [wholeState],
  (wholeState) => wholeState.Auth.UI.loading || wholeState.Projects.UI.loading || wholeState.Projects.UI.restoringProject || wholeState.Projects.UI.restoringGroup,
);